import { signOutAction } from '@onhandtech/onhand-fe-shared/lib/firebase'
import { Icon } from '@onhandtech/onhand-toolkit'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import NavigationItems from './navigation-items'
import * as CSS from './navigation-bar.styles'

const NavigationBar = () => {
  const dispatch = useDispatch()
  const { formatMessage } = useIntl()

  return (
    <CSS.NavigationBar data-testid="odin--navigation">
      <CSS.LogoContainer>
        <CSS.Logo>
          <img
            alt={formatMessage({ id: 'common.logo.alt' })}
            src="/static/img/logo_compact.png"
            width={30}
          />
        </CSS.Logo>
      </CSS.LogoContainer>
      <NavigationItems />
      <CSS.LogOutButton onClick={() => dispatch(signOutAction())} data-testid="button--logout">
        {formatMessage({ id: 'common.ui.button.log-out' })}
        <Icon color="earth" name="sign-out" />
      </CSS.LogOutButton>
    </CSS.NavigationBar>
  )
}

export default NavigationBar
